import {
  saveToken,
  saveLoginStatus,
  saveUserInfo,
  removeToken,
  removeUserInfo,
  removeLoginStatus,
  loadLoginStatus,
  loadToken,
  loadUserInfo,
  loadOpenId,
  saveOpenId,
  removeOpenId,
  loadTempToken,
  saveTempToken,
  removeTempToken
} from '@/utils/cache'
import apiUserPage from "api/user-page";
import apiHomePage from "@/api/home-page/index"
import apiLoginPage from "@/api/login-page/index"
import db from '@/utils/db.js'
import utils from '@/utils/util'
import router from '@/router'
import { Toast } from 'vant';
const state = {
  loginStatus: loadLoginStatus(), // 登录状态
  token: loadToken(), // token
  userInfo: loadUserInfo(), // 用户登录信息
  openId: loadOpenId(), // openId
  tempToken: loadTempToken(),
}

const mutations = {
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_LOGIN_STATUS: (state, loginStatus) => {
    state.loginStatus = loginStatus
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_OPENID: (state, openId) => {
    state.openId = openId
  },
  SET_TEMP_TOKEN: (state, tempToken) => {
    state.tempToken = tempToken
  },
}

const actions = {
	setTempToken({commit}, tempToken) {
		console.log('tempToken-----', tempToken)
		commit('SET_TEMP_TOKEN', saveTempToken(tempToken))
	},
	removeTempToken({}) {
		removeTempToken()
	},

	getUserInfo({ commit }, data) {
		apiLoginPage.userInfo().then(res => {
			console.log('user info res is', res)
			let u = res.data
			return new Promise(resolve => {
				commit('SET_USERINFO', saveUserInfo(u))
				resolve()
			})
		}).catch(err => {

		})
	},

	// 根据code获取openId
	getOpenId({commit},code) {
		const data = {
			wxCode:code,
		}
		return new Promise((resolve, reject) => {
			apiUserPage.getOpenId(data)
			.then( res => {
				console.log('getOpenId返回结果----------',res)
				let openId = res.data
				commit('SET_OPENID', saveOpenId(openId))
				resolve()
			})
			.catch( err => {
				console.log('getOpenId方法报错---------' + err)
				reject(err)
			})

		})
	},

	// 绑定用户(获取token)
	bindUser({commit},data) {
		return new Promise((resolve, reject) => {
			// apiUserPage.userBind(data,{ customHandleError: true })

			apiUserPage.userBind(data)
			.then( res => {
				console.log('绑定用户返回结果----------',res)
				let data = res.data || {}
				// let token = data.token
				let openId = data.openId
				// commit('SET_TOKEN', saveToken(token))
				commit('SET_OPENID', saveOpenId(openId))
				resolve()
			})
			.catch( err => {
				console.log('bindUser方法报错---------',err)
				// Toast.fail({
				// 	message: '请检查用户名或密码是否输入正确', forbidClick: true,
				// })
				reject(err)
			})

		})
	},

  // 设置状态
  setLoginStatus({commit}, query) {
    if (query === 0 || query === 1) {
        // 上线打开注释，本地调试注释掉，保持信息最新
      removeToken()
      removeUserInfo()
	}
	console.log('query-----',query)
    // 设置不同的登录状态
    commit('SET_LOGIN_STATUS', saveLoginStatus(query))
  },


	// 刷新token（当token过期之后，根据openId重新获取token）
  refreshToken({commit}) {
	return new Promise((resolve, reject) => {
		// 移除原来的token
		removeToken()
		let param = {}
		let openId = loadOpenId()
		param.openId = openId
		apiHomePage.getToken(param)
		.then( res => {
			let data = res.data || {}
			let token = data.token
			let openId = data.openId
			commit('SET_TOKEN', saveToken(token))
			commit('SET_OPENID', saveOpenId(openId))
			// Toast.loading( { message: '加载中...', forbidClick: true, } )
			location.reload()
			resolve()
		})
		.catch( err => {
			console.log('getToken方法报错---------',err)
			router.push('/login')
			reject(err)
		})

	})
  },


  // 登出
  fedLogOut() {
    // 删除token，用户信息，登陆状态
    removeToken()
    removeUserInfo()
	removeLoginStatus()
	removeOpenId()
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
